<template>
    <div v-if="projectWithRouter && !hideNavigation && viewId">
        <ejs-button type="button" v-if="allowedButtons.indexOf('min') !== -1" :disabled="openedIn === 'min'" iconCss="fa fa-window-minimize" cssClass="e-flat" @click="openInMin" title="Minimize to main window"></ejs-button>
        <ejs-button type="button" v-if="allowedButtons.indexOf('max') !== -1" :disabled="openedIn === 'max'" iconCss="fa fa-maximize" cssClass="e-flat" @click="openInMax" title="Maximize to main window"></ejs-button>
        <ejs-button type="button" v-if="allowedButtons.indexOf('popup') !== -1" :disabled="openedIn === 'popup'" iconCss="fa fa-window-maximize" cssClass="e-flat" @click="openInPopUp" title="Open in dialog in main window"></ejs-button>
        <ejs-button type="button" v-if="allowedButtons.indexOf('window') !== -1 && !hideNewWindow" iconCss="e-icons e-open-link" cssClass="e-flat" @click="openInWindow" title="Open in new window"></ejs-button>
    </div>
</template>

<script>

import { defineAsyncComponent } from "vue";

let navigationButtonsCmp = {
    name: 'navigationButtons',
    props: {
        view: {
            default: 'window'
        },
        usedFrom: {
            default: false
        }
    },
    data() {
        return {
            viewId: false,
            hideNavigation: false,
            hideNewWindow: false
        };
    },
    computed: {
        navigationStore() {
            return typeof navigationStore === 'function' ? navigationStore() : {};
        },
        allowedButtons() {
            let allowedButtons = this.navigationStore?.allowedButtons ? library.cloneObj(this.navigationStore?.allowedButtons) : [];
            let disableButtons = [];
            if (this.usedFrom === 'history' || this.usedFrom === 'min') {
                disableButtons.push('min');
            }
            if (this.view === 'window' && window.top === window) {
                disableButtons.push('window');
            }
            /* if (window?.top?.name?.indexOf?.('System_') !== -1) {
                disableButtons.push('popup');
            } */
            for (let i in disableButtons) {
                let tmpIndex = allowedButtons.findIndex((tmp) => tmp === disableButtons[i]);
                if (tmpIndex >= 0) {
                    allowedButtons.splice(tmpIndex, 1);
                }
            }
            return allowedButtons;
        },
        openedIn() {
            return this.navigationStore?.views?.[this.viewId]?.openedIn || false;
        },
        projectWithRouter() {
            return this.navigationStore?.projectWithRouter || false;
        }
    },
    created() {
        if (this.view) {
            if (this.view.cId && this.view.cType) {
                if (window.location.href.indexOf('componentView') !== -1) {
                    this.hideNavigation = true;
                    return;
                }
                let config = {
                    cId: this.view.cId,
                    cType: this.view.cType
                };
                if (typeof this.view?.props === 'undefined') {
                    this.view.props = {};
                    for (let i in this.view) {
                        if (i === 'cId' || i === 'cType') continue;
                        this.view.props[i] = library.cloneObj(this.view[i]);
                    }
                }
                let cConfig = this.$store.state.componentStore.componentsConfig[this.view.cType];
                if (cConfig && cConfig?.props) {
                    for (let i in cConfig.props) {
                        let propName = 'prop' + library.capitalizeFirstLetter(i);
                        if (typeof this.view?.props?.[propName] !== 'undefined') config[propName] = this.view.props[propName];
                        if (typeof this.view?.props?.[propName] === 'function') {
                            this.hideNavigation = true;
                            break;
                        }
                    }
                    for (let i in this.view.props) {
                        if (i.startsWith('context')) {
                            config[i] = this.view.props[i];
                        }
                    }
                }
                delete config.contextDialogId;
                this.viewId = this.navigationStore?.createView?.(config);
            } else if (this.view === 'window' && window.name.indexOf('System_') === -1) {
                this.viewId = window.name;
            } else if (this.view?.windowName) {
                this.viewId = this.view.windowName;
            }
        }
    },
    methods: {
        openInPopUp() {
            this.navigationStore?.openIn?.(this.viewId, 'popup');
            return false;
        },
        openInWindow() {
            this.navigationStore?.openIn?.(this.viewId, 'window');
            return false;
        },
        openInMin() {
            this.navigationStore?.openIn?.(this.viewId, 'min');
            return false;
        },
        openInMax() {
            this.navigationStore?.openIn?.(this.viewId, 'max');
            return false;
        }

    },
    components: {
        'ejs-button': defineAsyncComponent(() => import('@common/syncfusion/button')),
    }
};

export { navigationButtonsCmp };
export default navigationButtonsCmp;
</script>

<style scoped>
</style>
